import { render, staticRenderFns } from "./ReceiptDetails.vue?vue&type=template&id=4e395ed9&scoped=true"
import script from "./ReceiptDetails.vue?vue&type=script&lang=ts"
export * from "./ReceiptDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptDetails.vue?vue&type=style&index=0&id=4e395ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e395ed9",
  null
  
)

export default component.exports